import ModelBase from "../../../../framework/core/mvvm/model_base";


const {ccclass, property} = cc._decorator;

@ccclass
export default class TableMatchModel extends ModelBase {

    constructor(){
        super();
    }

}
